webpackJsonp([13509116309915],{

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 1152px;\n  p {\n    margin: 0 auto 1rem;\n    text-align: center;\n    max-width: 40em;\n    width: 100%;\n  }\n  p:last-of-type {\n    font-size: 1.5rem;\n    margin-top: 2.5rem;\n  }\n'], ['\n  max-width: 1152px;\n  p {\n    margin: 0 auto 1rem;\n    text-align: center;\n    max-width: 40em;\n    width: 100%;\n  }\n  p:last-of-type {\n    font-size: 1.5rem;\n    margin-top: 2.5rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: #32F095;\n  border-radius: 4px;\n  margin-top: 2.5rem;\n  position: relative;\n  overflow: hidden;\n  a {\n      display: block;\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n  }\n  @media screen and (min-width: 960px) {\n    & {\n        padding-left: 24rem;\n    }\n    &::before {\n        background: #32F095 url(img/lifeway.jpeg) no-repeat center right;\n        background-size: cover;\n        background-blend-mode: multiply;\n        content: "";\n        display: block;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 24rem;\n    }\n  }\n  iframe {\n    display: block;\n    height: 400px;\n    width: 100%;\n  }\n'], ['\n  background: #32F095;\n  border-radius: 4px;\n  margin-top: 2.5rem;\n  position: relative;\n  overflow: hidden;\n  a {\n      display: block;\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n  }\n  @media screen and (min-width: 960px) {\n    & {\n        padding-left: 24rem;\n    }\n    &::before {\n        background: #32F095 url(img/lifeway.jpeg) no-repeat center right;\n        background-size: cover;\n        background-blend-mode: multiply;\n        content: "";\n        display: block;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 24rem;\n    }\n  }\n  iframe {\n    display: block;\n    height: 400px;\n    width: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject);
	var Map = _styledComponents2.default.div(_templateObject2);
	
	var Location = function Location() {
	  return _react2.default.createElement(
	    Section,
	    { id: '#location' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Location'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Conference will be held at LifeWay\u2019s new Corporate Headquarters:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '1 Lifeway Plaza,',
	      _react2.default.createElement('br', null),
	      'Nashville, TN'
	    ),
	    _react2.default.createElement(
	      Map,
	      null,
	      _react2.default.createElement('a', {
	        href: 'https://www.google.com/maps/dir/\'\'/LifeWay+Christian+Store,+1+Lifeway+Plaza,+Nashville,+TN+37234/@36.1646242,-86.862663,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x886466f5d469c4f5:0x90f66d0a948e9bb7!2m2!1d-86.7926229!2d36.1646446',
	        target: '_blank',
	        rel: 'noopener'
	      }),
	      _react2.default.createElement('iframe', {
	        src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3221.078490041846!2d-86.79481158428592!3d36.16464458008447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886466f5d469c4f5%3A0x90f66d0a948e9bb7!2sLifeWay+Christian+Store!5e0!3m2!1sen!2sus!4v1526338426319',
	        frameBorder: '0',
	        style: { border: 0 },
	        allowFullScreen: true
	      })
	    ),
	    _react2.default.createElement(
	      'figure',
	      null,
	      _react2.default.createElement('img', { src: '', alt: '' })
	    )
	  );
	};
	
	exports.default = Location;
	module.exports = exports['default'];

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _location = __webpack_require__(226);
	
	var _location2 = _interopRequireDefault(_location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationPage = function LocationPage() {
	  return _react2.default.createElement(_location2.default, null);
	};
	
	exports.default = LocationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-location-js-f8a107fdc73046f473f5.js